import { useEffect, useState } from "react";

import { StorageKey } from "../../enum/StorageKey";

import {
  setItemToLocalStorage,
  removeItemFromLocalStorage,
  getItemFromLocalStorage,
} from "../../util/local-storage";

export const useRememberMe = () => {
  const rememberedUsername = getItemFromLocalStorage(StorageKey.USERNAME) ?? "";
  const [username, setUsername] = useState(rememberedUsername);
  const [shouldRememberMe, setShouldRememberMe] = useState(
    rememberedUsername.length > 0
  );

  useEffect(() => {
    const trimmedUsername = username?.trim();

    if (shouldRememberMe && trimmedUsername) {
      setItemToLocalStorage(StorageKey.USERNAME, trimmedUsername);
    } else {
      removeItemFromLocalStorage(StorageKey.USERNAME);
    }
  }, [username, shouldRememberMe]);

  return { shouldRememberMe, setShouldRememberMe, username, setUsername };
};
